import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import heroTitleRo from "@/assets/hero-title.png";

// Preload the LCP hero image with the production-hashed URL.
// Doing this from JS (not index.html) ensures the URL matches Vite's emitted asset.
const lang = (typeof navigator !== "undefined" && navigator.language?.startsWith("en")) ? "en" : "ro";
if (lang === "ro") {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = heroTitleRo;
  link.fetchPriority = "high";
  document.head.appendChild(link);
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
